var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatpawBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6232 6.57026C19.4337 2.69338 23.1106 5.04767 21.2927 8.37277C19.577 10.8996 16.3064 9.52784 17.6232 6.57026Z",
    fill: "#00A5B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7346 7.89416C10.9296 12.6783 7.25737 3.11179 11.2488 3.24354C13.1974 3.60484 14.5146 6.0476 13.7346 7.89416Z",
    fill: "#00A5B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.751 14.3009C22.2791 16.3603 24.4642 16.4346 25.6659 15.2226C26.3935 14.8361 26.5425 13.9751 26.5648 13.018C26.0478 9.97325 23.0907 12.4464 22.751 14.3009Z",
    fill: "#00A5B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36724 8.32231C6.24901 9.11794 10.1912 12.7716 6.60196 13.9159C2.42935 15.5176 -0.953466 6.2487 4.36724 8.32231Z",
    fill: "#00A5B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7012 14.2354L11.7427 14.1936L11.779 14.1473C12.9517 12.6482 14.1226 12.3804 15.1072 12.5832C16.1871 12.8056 17.2736 13.6443 18.0461 14.7768L18.0621 14.8003L18.0795 14.8228C18.5948 15.4931 19.2513 16.1302 19.8532 16.7142L19.8818 16.742C20.877 17.7079 21.7141 18.5369 22.1435 19.4234C22.3456 19.8407 22.4407 20.2428 22.4199 20.6564C22.3991 21.0689 22.2594 21.5592 21.8925 22.1485C20.354 24.5302 17.5198 25.2509 14.6549 24.9072C13.2376 24.7372 11.8821 24.3093 10.7968 23.7483C9.68513 23.1736 8.97167 22.52 8.68134 21.9714C7.90349 20.5014 7.72908 19.3542 7.75661 18.5385C7.78419 17.7211 8.01644 17.174 8.1472 16.898C8.25773 16.6647 8.50344 16.2975 8.83307 15.9445C9.16861 15.5851 9.50627 15.3318 9.76597 15.2262C9.9769 15.1404 10.1563 15.073 10.3191 15.0123C10.3331 15.0071 10.347 15.0019 10.361 14.9967C10.5041 14.9434 10.6499 14.8891 10.7816 14.834C11.099 14.7012 11.4019 14.5372 11.7012 14.2354Z",
    stroke: "#00A5B8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatpawBlue);
export default __webpack_public_path__ + "static/media/catpaw-blue.24c233eaa17d41c748650c4e6d00a062.svg";
export { ForwardRef as ReactComponent };